import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {TabPanel} from "../../../components/tab-panel-comp";
import {useTranslation} from "react-i18next";


export const TabDelivery = ({tabValue, distributor}) => {
    const {t} = useTranslation();
    return (
        <TabPanel value={tabValue} index={3} typePanel="distributor">
            <Box sx={{maxWidth: 800, mx: "auto"}}>
                <Typography variant="h6" gutterBottom sx={{display: "flex", alignItems: "center"}}>
                    <LocalShippingIcon sx={{mr: 1}}/> {t("DeliveryOptions")}
                </Typography>

                {distributor.deliveryOptions && distributor.deliveryOptions.length > 0 ? (
                    <Grid container spacing={3}>
                        {distributor.deliveryOptions.map((option, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card variant="outlined" sx={{height: "100%"}}>
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            {option}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {index === 0
                                                ? t("StandardDeliveryDescription")
                                                : index === 1
                                                    ? t("ExpressDeliveryDescription")
                                                    : t("PickupDescription")}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography variant="body1">{t("NoDeliveryInfoAvailable")}</Typography>
                )}

                <Box sx={{mt: 4}}>
                    <Typography variant="h6" gutterBottom>
                        {t("DeliveryPolicy")}
                    </Typography>
                    <Typography variant="body1" paragraph>
                        {t("DeliveryPolicyDescription")}
                    </Typography>
                </Box>
            </Box>
        </TabPanel>
    )
}